export class BuyerRegistrationModel {
    public firstName: string;
    public lastName: string;
    public email: string;
    public companyName: string;
    public password: string;
}
